import { PlayerBaseInfoContent } from '../../player-manager/context/PlayerBaseInfoProvider';

export const getTrailerContentId = (baseInfo: PlayerBaseInfoContent) => {
    if (baseInfo?.__typename === 'OttTrailer') {
        return baseInfo.contentGroupUuid;
    }

    return '';
};
